<nav class="navbar navbar-expand-lg navbar-absolute navbar-transparent navbar-{{ brand }}">
    <div class="container-fluid">
        <div class="navbar-wrapper">
            <div class="navbar-toggle d-inline" id="buger-menu">
                <button type="button" class="navbar-toggler" (click)="toggleMenu()">
                    <span class="navbar-toggler-bar bar1"></span>
                    <span class="navbar-toggler-bar bar2"></span>
                    <span class="navbar-toggler-bar bar3"></span>
                </button>
            </div>
        </div>
    </div>
</nav>
<div [id]="'menu-style-' + brand" class="sidebar">
    <div [className]="(
            customer && [null, ''].indexOf(customer.email) === -1 &&
            [null, ''].indexOf(customer.lastName) === -1 &&
            [null, ''].indexOf(customer.firstName) === -1 &&
            brand == 'lacarte'
        ) ||  brand !== 'lacarte' ? 'sidebar-wrapper' : 'sidebar-wrapper first-connexion'"
    >
        <div class="logo-area">
            <a href="{{ vitrineUrl }}" class="logo-item">&nbsp;</a>
        </div>
        @if (
                (
                        brand == 'lacarte' &&
                        customer &&
                        [null, ''].indexOf(customer.email) === -1 &&
                        [null, ''].indexOf(customer.lastName) === -1 &&
                        [null, ''].indexOf(customer.firstName) === -1
                ) ||
                brand !== 'lacarte'
        ) {
            <ul class="nav">
                <li [ngClass]="linesMenu">
                    <a class="nav-link" (click)="goTo('lignes')">
                        <span class="tim-icons icon-lines"></span>
                        <label [ngClass]="{'underline': linesMenu != ''}">Lignes</label>
                    </a>
                </li>
                @if (brand !== 'lacarte') {
                    <li [ngClass]="landLinesMenu">
                        <a class="nav-link" (click)="goTo('fixes')">
                            <span class="tim-icons icon-landlines"></span>
                            <label [ngClass]="{'underline': landLinesMenu != ''}">Fixes</label>
                        </a>
                    </li>
                }
                <li [ngClass]="billsMenu">
                    <a class="nav-link" (click)="goTo('factures')">
                        <span class="tim-icons icon-bills"></span>
                        <label [ngClass]="{'underline': billsMenu != ''}">Factures</label>
                    </a>
                </li>
                <li [ngClass]="paymentsMenu">
                    <a class="nav-link" (click)="goTo('paiements')">
                        <span class="tim-icons icon-payments"></span>
                        <label [ngClass]="{'underline': paymentsMenu != ''}">Paiements</label>
                    </a>
                </li>
                <li [ngClass]="accountMenu">
                    <a class="nav-link" (click)="goTo('compte')">
                        <span class="tim-icons icon-account"></span>
                        <label [ngClass]="{'underline': accountMenu != ''}">Mes infos</label>
                    </a>
                </li>
                @if (proFleetToken) {
                    <li [ngClass]="proFleetMenu">
                        <a class="nav-link" target="_blank" (click)="displayProFleetModal()">
                            <span class="tim-icons icon-vector"></span>
                            <label [ngClass]="{'underline': forumMenu != ''}">Mes comptes</label>
                        </a>
                    </li>
                }
                @if (brand !== 'lacarte') {
                    <li [ngClass]="forumMenu">
                        <a class="nav-link" target="_blank" (click)="goTo('dimelo')">
                            <span class="tim-icons icon-forum"></span>
                            <label [ngClass]="{'underline': forumMenu != ''}">FAQ</label>
                        </a>
                    </li>
                }
                @if (brand === 'prixtel') {
                    <li [ngClass]="sponsorshipMenu">
                        <a class="nav-link" (click)="goTo('parrainage')">
                            <span class="tim-icons icon-star"></span>
                            <label [ngClass]="{'underline': sponsorshipMenu != ''}">Parrainage</label>
                        </a>
                    </li>
                }
                <li class="menu-logout">
                    <a class="nav-link logout-link" (click)="logout()">
                        <span class="tim-icons icon-button-power"></span>
                        <label>Déconnexion</label>
                    </a>
                </li>
            </ul>
        }
        @if (customer && [null, ''].indexOf(customer.email) !== -1) {
            <ul class="nav">
                <li class="menu-logout">
                    <a class="nav-link logout-link" (click)="logout()">
                        <span class="tim-icons icon-button-power"></span>
                        <label>Déconnexion</label>
                    </a>
                </li>
            </ul>
        }
    </div>
</div>
@if (menuOpen) {
    <div class="nav-overlay" (click)="simulateClickMenuButton()"></div>
}
